import { Create } from '@fund/api-modules';
// import { getApiHostWithoutEnv } from '@fund/api-host';
import CreateByUser from './decorator/CreateByUser';

@CreateByUser({
  getUserParams: (userInfo) => {
    const {
      utoken,
      ctoken,
      uid,
      deviceid,
    } = userInfo;
    return {
      utoken,
      ctoken,
      deviceid,
      version: '6.5.5',
      customerNo: uid,
      mobileKey: deviceid,
      product: 'EFund',
      plat: 'web',
    };
  },
})

@Create({
  // baseURL: getApiHostWithoutEnv('push2His'), // 更多地址参考 https://acttest.1234567.com.cn/topic/2019/fund-config/api
  baseURL: 'https://push2his.eastmoney.com',
  params: {
    deviceid: '1234567.py.service',
    version: '6.5.5',
    appVersion: '6.5.5',
    product: 'EFund',
    plat: 'web',
  },
})

class Push2His {
  getKLineData(params) {
    return this.GET('/api/qt/stock/kline/get', {
      ...params,
    });
  }
}
export default new Push2His();
